import * as React from "react";
import * as moment from "moment";
import { Link } from "react-router-dom";
import { Row, Col, Button } from "reactstrap";
import styled from "@emotion/styled";

import { Colors } from "../../Themes";

const LogoText = styled.div`
  font-family: "PB", sans-serif;
  font-size: 4.75em;
  color: ${Colors.cmmsBlue};
`;

const FooterContainer = styled.div`
  background: ${Colors.snow};
  margin-top: 150px;
`;

const FooterBottom = styled.div`
  background: ${Colors.cmmsBlue};
  text-align: center;
  padding-top: 30px;
  padding-bottom: 30px;
`;

const FooterMargins = styled.div`
  margin-left: 40px;
  margin-right: 40px;
`;

const SubText = styled.span`
  font-weight: 100;
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
`;

const SubTextSmall = styled.span`
  font-weight: 100;
  font-family: "Montserrat", sans-serif;
  color: #fff;
  font-size: 0.81em;
`;

const btnStyling = {
  width: "180px"
};

class Footer extends React.Component<{}> {
  render() {
    return (
      <FooterContainer>
        <FooterMargins>
          <Row style={{ paddingBottom: "80px" }}>
            <Col xs={12} md={12} lg={12} className="center-align">
              <LogoText>maintain.</LogoText>
              <br />
              <SubText>
                A better way to manage work orders and get great results from
                your maintenance teams.
              </SubText>
              <br />
              <br />
              <br />
              <Link to="/sign-up">
                <Button style={btnStyling}>Get Started Today For Free</Button>
              </Link>
            </Col>
          </Row>
        </FooterMargins>
        <FooterBottom>
          <SubTextSmall>
            All rights reserved &copy; Copyright {moment().format("YYYY")}{" "}
            Maintain CMMS. Read our{" "}
            <Link
              to="/privacy-policy"
              style={{ color: "#f2f2f2", textDecoration: "underline" }}
            >
              Privacy Policy
            </Link>{" "}
            and{" "}
            <Link
              to="/terms"
              style={{ color: "#f2f2f2", textDecoration: "underline" }}
            >
              Terms of Service
            </Link>
            .
          </SubTextSmall>
          <br />
          <br />
          <SubTextSmall>
            All Registered Trade Marks, company names, brand names and logos
            used on this Website are the property of their respective owners.
          </SubTextSmall>
        </FooterBottom>
      </FooterContainer>
    );
  }
}

export default Footer;



// WEBPACK FOOTER //
// ./src/Containers/Home/Footer.tsx